import React from "react";
import { IoArrowForwardOutline, IoBookOutline, IoSearchOutline, IoSparklesOutline } from "react-icons/io5";
import "./SemguruSection.css";

const SemguruSection = () => {
  return (
    <section className="section semguru" aria-label="SemGuru migration notice">
      <div className="container semguru-container">
        <div className="semguru-content">
          <p className="section-subtitle">A new home for your studies</p>
          <h2 className="h2 section-title">
            VInTogether is now <span className="span">SemGuru</span>
          </h2>
          <p className="section-text">
            The same study material you know is now rebuilt and better organised on SemGuru,
            with easier search and more useful exam-season resources.
          </p>

          <div className="semguru-actions">
            <a
              href="https://semguru.in"
              className="btn has-before semguru-primary"
              target="_blank"
              rel="noreferrer"
            >
              <span className="span">Continue to SemGuru</span>
              <IoArrowForwardOutline aria-hidden="true" />
            </a>
          </div>

          <p className="semguru-note">Still completely free. Nothing to sign up for.</p>
        </div>

        <div className="semguru-visual" aria-label="SemGuru benefits">
          <div className="semguru-path">
            <div className="semguru-brand semguru-brand-old">
              <img src="/logovin.jpg" alt="VInTogether logo" />
            </div>
            <IoArrowForwardOutline className="semguru-path-arrow" aria-hidden="true" />
            <div className="semguru-brand semguru-brand-new">
              <img src="/icon-512x512.png" alt="SemGuru logo" />
            </div>
          </div>

          <div className="semguru-benefits">
            <div>
              <IoBookOutline aria-hidden="true" />
              <span>Everything you already use</span>
            </div>
            <div>
              <IoSearchOutline aria-hidden="true" />
              <span>Easier to find what you need</span>
            </div>
            <div>
              <IoSparklesOutline aria-hidden="true" />
              <span>More built for exam season</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SemguruSection;
